import createTypes from 'redux-create-action-types';

export default createTypes(
  'GET_QC_INSPECTION_ALL_JOBS',
  'GET_QC_INSPECTION_THIRD_PARTY_JOBS',
  'GET_QC_INSPECTION_INHOUSE_JOBS',
  'GET_QC_INSPECTION_DRAFT_JOBS',
  'GET_SERVICE_PROVIDERS',
  'GET_INSPECTION_TYPE',
  'SYNC_UPDATE_QC_INSPECTION_FILTERS'
);
